export default __webpack_public_path__ + "static/media/sole-2.06df6150.jpg";